export default __webpack_public_path__ + "static/media/thumbs_up.e3bf974d.png";